import admin from 'firebase-admin';

if (!process.env.FIREBASE_CREDENTIALS) 
  throw new Error('Missing FIREBASE_CREDENTIALS environment variable');

const serviceAccount = JSON.parse(
  Buffer.from(process.env.FIREBASE_CREDENTIALS, 'base64').toString('utf8'),
);

if (!admin.apps.length) 
  admin.initializeApp({
    credential: admin.credential.cert(serviceAccount),
  });


export const firebaseAdmin = admin;
export const firestore = admin.firestore();
export const auth = admin.auth();
export const messaging = admin.messaging();
